import { Box, useDisclosure } from '@chakra-ui/react';
import useTagManager from 'hooks/useTagManager';
import useRUM from 'hooks/useRUM';
import { FC } from 'react';
import { Outlet } from 'react-router';

import './App.css';
import MSidebar from './components/molecules/MSidebar/MSidebar';

const App: FC = () => {
    const disclosure = useDisclosure();
    const { onOpen, onClose } = disclosure;

    useTagManager();
    useRUM();

    return (
        <Box bgColor="bgGray" minH="100%" w="100%">
            <Box onMouseMove={onOpen}>
                <MSidebar {...disclosure} />
            </Box>
            <Box
                w="100%"
                h="100vh"
                pl="60px"
                boxSizing="border-box"
                onMouseMove={onClose}
                top={0}
                overflow="auto"
                pb={2}
            >
                <Outlet />
            </Box>
        </Box>
    );
};

export default App;
